import "./index.scss";

export const HomeContainer = ({ children }) => {
  return (
    <div className="home-container">
      <div className="home-component-container">{children}</div>
    </div>
  );
};
